import { render, staticRenderFns } from "./carPlaceList.vue?vue&type=template&id=8af9e2c2&"
import script from "./carPlaceList.vue?vue&type=script&lang=js&"
export * from "./carPlaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports